import { useFormik } from "formik"
import * as Yup from "yup"
import TextField from "components/TextField"
import AddTeammate from "../AddTeammate"
import { useState } from "react"
import Table from "components/Table/Table"
import Button from "components/Button"
import commonFunctions from "utils/CommonFunctions"
import RadioButton from "components/RadioButton"
import SelectMenu from "../../../../components/SelectMenu"

const Volleyball = ({ registerEvent, event = null }) => {
  const [openAddPlayer, setOpenAddPlayer] = useState(false)
  const [category, setCategory] = useState(null)
  const [categoryError, setCategoryError] = useState(false)
  const [registerThrough, setRegisterThrough] = useState(null)
  const [players, setPLayers] = useState([])
  const [skillLevel, setSkillLevel] = useState(null)
  const [skillLevelError, setSkillLevelError] = useState(null)
  const [allFieldsValidated, setAllFieldsValidated] = useState(false)
  const costType = "default"

  const columns = [
    {
      name: "Firstname",
      selector: "firstName",
      cell: (row) => <span>{row.firstName}</span>,
    },
    {
      name: "Lastname",
      selector: "lastName",
    },
    {
      name: "Contact number",
      selector: "contactNumber",
    },
    {
      name: "Actions",
      selector: "action",
      style: { width: "40px" },
      cell: (_, index) => (
        <div className="flex items-center space-x-2">
          <button
            title="Mark As Unread"
            onClick={(e) => {
              e.preventDefault()
              handleRemovePLayer(index)
            }}
            className="text-gray-700 px-2 py-1 border border-gray-300 rounded-lg shadow hover:bg-gray-200 transition duration-100"
          >
            Remove
          </button>
        </div>
      ),
    },
  ]

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      teamName: "",
      primaryContactName: "",
      email: "",
      confirmEmail: "",
      phone: "",
      alternatePhone: "",
    },
    validationSchema: Yup.object().shape({
      teamName: Yup.string().required("Required"),
      primaryContactName: Yup.string().required("Required"),
      email: Yup.string().required("Required"),
      confirmEmail: Yup.string()
        .required("Required")
        .oneOf([Yup.ref("email"), null], "Email must match"),
      phone: Yup.string().required("Required"),
    }),
    onSubmit: (values) => {
      if (category === null) {
        setCategoryError(true)
      } else {
        if (!allFieldsValidated) return
        
        values["players"] = players
        values["registerThrough"] = registerThrough
        values["teamType"] = category
        values["eventCost"] = event.eventCost[costType]
        values["phone"] = commonFunctions.phoneNumberToText(values["phone"])
        values["alternatePhone"] = commonFunctions.phoneNumberToText(values["alternatePhone"])
        values["skillLevel"] = skillLevel ? skillLevel?.value : 1
        registerEvent(values)
      }
    },
  })

  const validateOtherFields = () => {
    let hasIssues = false

    if (skillLevel == null || skillLevel?.value === null) {
      setSkillLevelError("Required")
      hasIssues = true
    }

    setAllFieldsValidated(!hasIssues)

    return hasIssues
  }

  const handleAddPlayer = (player) => {
    setPLayers([...players, player])
  }

  const handleRemovePLayer = (index) => {
    let newPlayers = [...players]
    newPlayers.splice(index, 1)
    setPLayers(newPlayers)
  }

  return (
    <section>
      <AddTeammate open={openAddPlayer} setOpen={setOpenAddPlayer} handleAddPlayer={handleAddPlayer} />

      <form className="space-y-4 md:space-y-6">
        <div className="grid grid-cols-1 gap-6 mt-4 sm:grid-cols-2">
          <div>
            <TextField
              label="Name of your team"
              name="teamName"
              type="text"
              value={formik.values.teamName}
              onChange={formik.handleChange}
              error={formik.errors.teamName}
              touched={formik.touched.teamName}
              onBlur={formik.handleBlur}
              required
            />
          </div>
          <div>
            <SelectMenu
                label="Skill Level"
                name="skillLevel"
                // items={[
                //   { name: '1.0 - 2.0 [Beginner]', value: 1 }, 
                //   { name: '2.5 - 3.5 [Medium]', value: 2 }, 
                //   { name: '4.0 + [Advanced]', value: 3 }
                // ]}
                items={[
                  { name: 'Beginner', value: 1 }, 
                  { name: 'Intermediate', value: 2 }, 
                  { name: 'Advanced', value: 3 },
                  // { name: '5.00 - 8.00 [Professional]', value: 4 }
                ]}
                value={skillLevel?.value}
                onChange={(data) => {
                  setSkillLevel(data)
                  setSkillLevelError(null)
                }}
                hasError={skillLevelError}
                error={skillLevelError}
                required
              />
            </div>
          <div>
            <TextField
              label="Name of primary contact"
              name="primaryContactName"
              type="text"
              value={formik.values.primaryContactName}
              onChange={formik.handleChange}
              error={formik.errors.primaryContactName}
              touched={formik.touched.primaryContactName}
              onBlur={formik.handleBlur}
              required
            />
          </div>

          <div>
            <TextField
              label="Email"
              name="email"
              type="text"
              value={formik.values.email}
              onChange={formik.handleChange}
              error={formik.errors.email}
              touched={formik.touched.email}
              onBlur={formik.handleBlur}
              required
            />
          </div>
          <div>
            <TextField
              label="Confirm Email"
              name="confirmEmail"
              type="text"
              value={formik.values.confirmEmail}
              onChange={formik.handleChange}
              error={formik.errors.confirmEmail}
              touched={formik.touched.confirmEmail}
              onBlur={formik.handleBlur}
              required
            />
          </div>

          <div>
            <TextField
              label="Phone number"
              name="phone"
              type="text"
              placeholder="(XXX) XXX-XXXX"
              phoneNumberFormat={true}
              value={formik.values.phone}
              onChange={formik.handleChange}
              error={formik.errors.phone}
              touched={formik.touched.phone}
              onBlur={formik.handleBlur}
              required
            />
          </div>
          <div>
            <TextField
              label="Alternate phone number"
              name="alternatePhone"
              type="text"
              placeholder="(XXX) XXX-XXXX"
              phoneNumberFormat={true}
              value={formik.values.alternatePhone}
              onChange={formik.handleChange}
              error={formik.errors.alternatePhone}
              touched={formik.touched.alternatePhone}
              onBlur={formik.handleBlur}
            />
          </div>
        </div>

        <div>
          <label htmlFor={"category"} className="block text-sm font-medium text-gray-700 mb-3">
            Participant Category
            <span className="text-md text-red-500">*</span>
          </label>
          <div className="flex items-center mb-2">
            <RadioButton
              name="volleyball"
              value="volleyball"
              onChange={(e) => {
                setCategory(e.target.value)
                setCategoryError(false)
              }}
              error={categoryError}
            >
              Volleyball
            </RadioButton>
          </div>
          <div className="flex items-center">
            <RadioButton
              name="throwball"
              value="throwball"
              onChange={(e) => {
                setCategory(e.target.value)
                setCategoryError(false)
              }}
              error={categoryError}
            >
              Throwball
            </RadioButton>
          </div>
          {categoryError && <span className="text-red-600 text-xs">Required</span>}
        </div>

        <div>
          <label htmlFor={"category"} className="block text-sm font-medium text-gray-700 mb-3">
            Team Info
          </label>
          <Button
            onClick={() => {
              if (players.length >= event?.maxPlayers) {
                alert("You can only add up to " + event?.maxPlayers + " players. ")
              } else {
                setOpenAddPlayer(true)
              }
            }}
          >
            Add Player
          </Button>
          <div className="text-sm">You can add players up to {event?.maxPlayers}</div>

          <Table columns={columns} data={players} loading={false} disableFooter={true} />
        </div>
      </form>

      <div className="bg-gray-50 py-3 sm:flex sm:flex-row-reverse">
        <Button
          className="sm:mb-0 sm:ml-3 w-full mb-3"
          onClick={() => {
            validateOtherFields()
            setRegisterThrough("OFFLINE")
            formik.handleSubmit()
          }}
        >
          Register Offline
        </Button>

        <Button
          className="w-full"
          onClick={() => {
            validateOtherFields()
            setRegisterThrough("PAYPAL")
            formik.handleSubmit()
          }}
        >
          Register With Paypal
        </Button>
      </div>
    </section>
  )
}

export default Volleyball
